export default {
    cz: {
        title: 'Mohlo by se vám hodit',
    },
    sk: {
        title: 'Mohlo by sa vám hodiť',
    },
}
